import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import _ from 'lodash';
import actions from '../../redux/actions';
import getContent from './Contents/Ownership';

class Ownership extends Component {
  options = () => ({
    composition: this.props.composition,
    consent: this.props.consent,
  });

  handleContent(field, value) {
    const options = this.options();
    options[field] = value;
    this.props.updateBlock(this.props.block.id, getContent(options), options);

    const paymentBlock = _.find(
      this.props.filterBlocks,
      (block) => block.name === 'Payments'
    );
    if (field === 'composition' && value === 1) {
      if (
        paymentBlock.options &&
        paymentBlock.options.statutoryPercentage === ''
      ) {
        this.props.alert(
          'error',
          'You have selected an option that requires you to change your answers in the Payment tab next.'
        );
      }
    }

    if (field === 'composition' && value === 0) {
      // Remove payment statutory percent if the composition value is 0
      if (
        paymentBlock.options &&
        paymentBlock.options.statutoryPercentage !== ''
      ) {
        const paymentOptions = {
          ...paymentBlock.options,
          statutoryPercentage: '',
          day: '',
        };
        this.props.updateBlock(
          paymentBlock.id,
          getContent(paymentOptions),
          paymentOptions
        );
      }
    }
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <div className="questions">
              <p className="question">
                Does the Producer have a claim of ownership or authorship of the
                musical composition(s)?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="composition"
                  checked={this.props.composition === 0}
                  readOnly
                  onClick={(e) => this.handleContent('composition', 0)}
                >
                  No
                </Radio>
                <Radio
                  name="composition"
                  checked={this.props.composition === 1}
                  readOnly
                  onClick={(e) => this.handleContent('composition', 1)}
                >
                  Yes
                </Radio>
              </FormGroup>

              <p className="question">
                Can the Producer distribute, display, reproduce, or otherwise
                use the recording(s) without written permission?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="consent"
                  checked={this.props.consent === 0}
                  readOnly
                  onClick={(e) => this.handleContent('consent', 0)}
                >
                  No
                </Radio>
                <Radio
                  name="consent"
                  checked={this.props.consent === 1}
                  readOnly
                  onClick={(e) => this.handleContent('consent', 1)}
                >
                  Yes
                </Radio>
              </FormGroup>
            </div>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Taking the time now to outline permissions around the usage of
                  the music clears up any confusion and helps you to avoid
                  serious legal and financial issues caused by using the music
                  without proper permission.
                </p>
                <p className="small">
                  Under this agreement, the Producer will not own any of the
                  master(s). If the Producer owns a part of the musical
                  composition(s), there are other questions Cosynd will need to
                  ask you in the “Payments” section. You will also need to
                  attach a copyright split agreement (“split sheet”) to your
                  Producer agreement after it is completed.&nbsp; If you don't
                  have a split sheet in place, you can create one for free on
                  Cosynd.
                </p>
              </div>
              <div className="expand" tabIndex="1">
                <p className="question">What is a "musical composition?"</p>
                <p className="small">
                  A song is composed of two copyrights: 1) the sound recording
                  (the master) and 2) the musical composition (the written
                  lyrics and musical arrangement). A musical composition
                  consists of the written melody, notation, musical arrangement,
                  and lyrics.
                </p>
                <p className="small">
                  Under this agreement, the Producer will not own the sound
                  recording(s). If they do own a portion of the musical
                  composition(s), you should indicate that here now.
                </p>
              </div>
              <div className="expand" tabIndex="2">
                <p className="question">
                  What will I need if a Producer has a claim of
                  ownership/authorship of the musical composition(s)?
                </p>
                <p className="small">
                  After you have completed your Producer agreement, you should
                  attach a copyright split agreement (“split sheet”) to it for
                  each song that outlines all of the owners of the musical
                  composition(s). If you don’t already have a split sheet
                  agreement, you can create split sheets on Cosynd for free.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
});

export default connect(null, mapDispatchToProps)(Ownership);



// WEBPACK FOOTER //
// src/components/ContractBlock/Ownership.jsx